if (!customElements.get('soodox-quantity-total')) {
  customElements.define('soodox-quantity-total', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.scope = this.closest('product-info,soodox-hair-bundle') || this.form;
      if (!this.form || !this.scope) { console.warn('Soodox subtotal: form missing'); return; }
      try {
        this.prices = JSON.parse(this.querySelector('[data-quantity-prices]').textContent);
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en-AU', {
          style: 'currency', currency: this.dataset.currency || 'AUD'
        });
      } catch (error) { console.warn('Soodox subtotal setup', error.message); return; }
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateTotal(); });
      };
      this.scope.addEventListener('input', this.schedule);
      this.scope.addEventListener('change', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.scope, { childList: true, subtree: true });
      this.updateTotal();
    }
    updateTotal() {
      const quantityInput = this.form.elements.namedItem('quantity');
      const count = quantityInput ? Number(quantityInput.value) : 1;
      const variantId = this.form.elements.namedItem('id')?.value;
      const variant = this.prices.find(item => String(item.id) === String(variantId));
      if (!variant || !Number.isSafeInteger(count) || count <= 1) {
        this.hidden = true;
        return;
      }
      let unitPrice = Number(variant.price);
      const combinedQuantity = count + Number(quantityInput?.dataset.cartQuantity || 0);
      for (const tier of [...variant.breaks].sort((a, b) => a.minimum - b.minimum)) {
        if (combinedQuantity >= tier.minimum) unitPrice = Number(tier.price);
      }
      const subtotal = unitPrice * count;
      if (!Number.isSafeInteger(subtotal)) { this.hidden = true; return; }
      const calculation = count + ' × ' + this.money.format(unitPrice / 100);
      const total = this.money.format(subtotal / 100);
      const calculationNode = this.querySelector('[data-quantity-calculation]');
      const totalNode = this.querySelector('[data-quantity-subtotal]');
      if (calculationNode.textContent !== calculation) calculationNode.textContent = calculation;
      if (totalNode.textContent !== total) totalNode.textContent = total;
      this.hidden = false;
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('input', this.schedule);
      this.scope?.removeEventListener('change', this.schedule);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
